import React, {useState} from "react";
import router, {Route} from "@/routing/Router";
import {SetFeaturedProductProps} from "@pages/authenticated/admin/products/FeaturedProduct";
import FeaturedProductHeading from "@widgets/featuredProducts/editor/heading/FeaturedProductHeading";
import SlimContainer from "@widgets/layout/SlimContainer";
import EditFeaturedProductCard from "@widgets/featuredProducts/editor/card/EditFeaturedProductCard";
import DeleteFeaturedProductModal from "@widgets/featuredProducts/delete/DeleteFeaturedProductModal";
import {useNavigate} from "react-router-dom";
import {FormProvider, useForm} from "react-hook-form";
import {FeaturedProductFormValues} from "@/data/entities/product";

type Props = SetFeaturedProductProps & {
    restaurantId: number,
    route: Route,
    initialLoading: boolean,
};

const FeaturedProductEditor = ({route, initialLoading, featuredProduct, setFeaturedProduct, restaurantId}: Props) => {
    const navigate = useNavigate();
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const formMethods = useForm<FeaturedProductFormValues>();

    return (
        <>
            <FormProvider {...formMethods}>
                <FeaturedProductHeading
                    route={route}
                    initialLoading={initialLoading}
                    featuredProduct={featuredProduct}
                    setFeaturedProduct={setFeaturedProduct}
                    setShowDeleteModal={setShowDeleteModal}
                />

                <SlimContainer center={false} className={"mt-6 md:mt-12"}>
                    <EditFeaturedProductCard
                        featuredProduct={featuredProduct}
                        setFeaturedProduct={setFeaturedProduct}
                        initialLoading={initialLoading}
                        restaurantId={restaurantId}
                    />
                </SlimContainer>
            </FormProvider>

            {
                featuredProduct &&
                <DeleteFeaturedProductModal
                    show={showDeleteModal}
                    setShow={setShowDeleteModal}
                    featuredProductId={featuredProduct.id}
                    cb={() => navigate(router.featuredProducts.absolutePath())}
                />
            }
        </>
    );
};

export default FeaturedProductEditor;